var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3304.5,
    height: 3304.54,
    viewBox: "0 0 3304.5 3304.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 0 0 L 3304.5 0 L 3304.5 3304.539062 L 0 3304.539062 Z M 0 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 1652.25 390.109375 C 956.257812 390.109375 390.078125 956.300781 390.078125 1652.269531 C 390.078125 2348.269531 956.257812 2914.441406 1652.25 2914.441406 C 2348.230469 2914.441406 2914.429688 2348.238281 2914.429688 1652.269531 C 2914.429688 956.308594 2348.199219 390.109375 1652.25 390.109375 Z M 968.585938 1754.011719 L 1407.589844 2193.039062 L 2335.910156 1264.71875 L 2182.730469 1111.539062 L 1447.25 1847.019531 C 1425.320312 1868.949219 1389.800781 1868.949219 1367.890625 1847.019531 L 1121.75 1600.828125 Z M 1407.589844 2328.519531 C 1422.46875 2328.519531 1436.75 2322.578125 1447.269531 2312.070312 L 2455 1304.351562 C 2476.898438 1282.429688 2476.898438 1246.910156 2455 1224.988281 L 2222.441406 992.449219 C 2200.511719 970.519531 2165 970.519531 2143.070312 992.449219 L 1407.601562 1727.929688 L 1161.441406 1481.769531 C 1139.519531 1459.839844 1104.011719 1459.839844 1082.078125 1481.769531 L 849.539062 1714.300781 C 827.621094 1736.230469 827.621094 1771.738281 849.539062 1793.671875 L 1367.910156 2312.070312 C 1378.410156 2322.578125 1392.691406 2328.519531 1407.589844 2328.519531 Z M 1652.25 112.25 C 803.0625 112.25 112.230469 803.089844 112.230469 1652.269531 C 112.230469 2501.449219 803.0625 3192.300781 1652.25 3192.300781 C 2501.429688 3192.300781 3192.261719 2501.449219 3192.261719 1652.269531 C 3192.261719 803.089844 2501.429688 112.25 1652.25 112.25 Z M 1652.25 3304.539062 C 2563.308594 3304.539062 3304.5 2563.351562 3304.5 1652.269531 C 3304.5 741.210938 2563.308594 0 1652.25 0 C 741.207031 0 0 741.21875 0 1652.269531 C 0 2563.328125 741.207031 3304.539062 1652.25 3304.539062 Z M 1652.25 3026.671875 C 894.402344 3026.671875 277.847656 2410.148438 277.847656 1652.269531 C 277.847656 894.410156 894.414062 277.878906 1652.25 277.878906 C 2410.078125 277.878906 3026.691406 894.441406 3026.691406 1652.269531 C 3026.691406 2410.101562 2410.078125 3026.671875 1652.25 3026.671875 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(3304.5, 0, 0, 3304.5, 0, 1652.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(13.33313%, 37.646484%, 37.646484%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "rgb(13.227844%, 37.477112%, 37.477112%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(13.020325%, 37.139893%, 37.139893%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "rgb(12.811279%, 36.802673%, 36.802673%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(12.602234%, 36.465454%, 36.465454%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "rgb(12.394714%, 36.129761%, 36.129761%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(12.185669%, 35.792542%, 35.792542%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "rgb(11.978149%, 35.455322%, 35.455322%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(11.769104%, 35.118103%, 35.118103%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "rgb(11.561584%, 34.780884%, 34.780884%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(11.352539%, 34.443665%, 34.443665%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "rgb(11.14502%, 34.106445%, 34.106445%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(10.935974%, 33.770752%, 33.770752%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "rgb(10.728455%, 33.433533%, 33.433533%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(10.519409%, 33.096313%, 33.096313%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "rgb(10.31189%, 32.759094%, 32.759094%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(10.102844%, 32.421875%, 32.421875%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "rgb(9.895325%, 32.084656%, 32.084656%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(9.686279%, 31.747437%, 31.747437%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(9.477234%, 31.410217%, 31.410217%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(9.269714%, 31.074524%, 31.074524%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "rgb(9.060669%, 30.737305%, 30.737305%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(8.853149%, 30.400085%, 30.400085%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "rgb(8.644104%, 30.062866%, 30.062866%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(8.436584%, 29.725647%, 29.725647%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "rgb(8.227539%, 29.388428%, 29.388428%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(8.02002%, 29.051208%, 29.051208%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "rgb(7.810974%, 28.715515%, 28.715515%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(7.603455%, 28.378296%, 28.378296%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "rgb(7.394409%, 28.041077%, 28.041077%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(7.18689%, 27.703857%, 27.703857%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(6.977844%, 27.366638%, 27.366638%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(6.770325%, 27.029419%, 27.029419%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(6.561279%, 26.6922%, 26.6922%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(6.352234%, 26.356506%, 26.356506%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(6.144714%, 26.019287%, 26.019287%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(5.935669%, 25.682068%, 25.682068%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(5.728149%, 25.344849%, 25.344849%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(5.519104%, 25.007629%, 25.007629%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(5.311584%, 24.67041%, 24.67041%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(5.102539%, 24.333191%, 24.333191%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(4.89502%, 23.997498%, 23.997498%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(4.685974%, 23.660278%, 23.660278%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(4.478455%, 23.323059%, 23.323059%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(4.269409%, 22.98584%, 22.98584%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(4.06189%, 22.648621%, 22.648621%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(3.852844%, 22.311401%, 22.311401%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(3.645325%, 21.974182%, 21.974182%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(3.436279%, 21.636963%, 21.636963%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(3.227234%, 21.30127%, 21.30127%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(3.019714%, 20.96405%, 20.96405%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(2.810669%, 20.626831%, 20.626831%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(2.603149%, 20.289612%, 20.289612%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(2.394104%, 19.952393%, 19.952393%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(2.186584%, 19.615173%, 19.615173%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(1.977539%, 19.277954%, 19.277954%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(1.77002%, 18.942261%, 18.942261%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(1.560974%, 18.605042%, 18.605042%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(1.353455%, 18.267822%, 18.267822%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(1.144409%, 17.930603%, 17.930603%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(0.93689%, 17.593384%, 17.593384%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(0.727844%, 17.256165%, 17.256165%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(0.520325%, 16.918945%, 16.918945%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(0.311279%, 16.583252%, 16.583252%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0.10376%, 16.246033%, 16.246033%)",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-0)",
    d: "M 0 0 L 0 3304.539062 L 3304.5 3304.539062 L 3304.5 0 Z M 0 0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b098ef0406ac06aecfc3247895cda71a.svg";
export { ForwardRef as ReactComponent };